var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "recommend" }, [
        _c(
          "div",
          {
            staticClass: "rec-card card1",
            style: { background: _vm.configObj.card1BgColor.color[0].item },
          },
          [
            _c("div", { staticClass: "card-head" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.configObj.card1Title.val)),
              ]),
              _vm.configObj.card1Tag.val
                ? _c("span", { staticClass: "corner-tag" }, [
                    _vm._v(_vm._s(_vm.configObj.card1Tag.val)),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "sub" }, [
              _vm._v(_vm._s(_vm.configObj.card1SubTitle.val)),
            ]),
            _c("div", { staticClass: "goods" }, [
              _c("div", { staticClass: "goods-img" }, [
                _vm.configObj.card1Img.url
                  ? _c("img", {
                      attrs: { src: _vm.configObj.card1Img.url, alt: "" },
                    })
                  : _c("div", { staticClass: "empty" }, [
                      _c("i", { staticClass: "el-icon-picture-outline" }),
                    ]),
              ]),
              _c("div", { staticClass: "goods-info" }, [
                _c("div", { staticClass: "g-name" }, [
                  _vm._v(_vm._s(_vm.configObj.card1GoodsName.val)),
                ]),
                _c("div", { staticClass: "g-desc" }, [
                  _vm._v(_vm._s(_vm.configObj.card1Desc1.val)),
                ]),
                _c("div", { staticClass: "g-desc" }, [
                  _vm._v(_vm._s(_vm.configObj.card1Desc2.val)),
                ]),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "rec-card card2",
            style: { background: _vm.configObj.card2BgColor.color[0].item },
          },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.configObj.card2Title.val)),
            ]),
            _c("div", { staticClass: "sub" }, [
              _vm._v(_vm._s(_vm.configObj.card2SubTitle.val)),
            ]),
            _c("div", { staticClass: "mid-img" }, [
              _vm.configObj.card2Img.url
                ? _c("img", {
                    attrs: { src: _vm.configObj.card2Img.url, alt: "" },
                  })
                : _c("div", { staticClass: "empty" }, [
                    _c("i", { staticClass: "el-icon-picture-outline" }),
                  ]),
            ]),
            _vm.configObj.card2Tag.val
              ? _c("div", { staticClass: "bottom-tag" }, [
                  _vm._v(_vm._s(_vm.configObj.card2Tag.val)),
                ])
              : _vm._e(),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "rec-card card3",
            style: { background: _vm.configObj.card3BgColor.color[0].item },
          },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.configObj.card3Title.val)),
            ]),
            _c("div", { staticClass: "sub" }, [
              _vm._v(_vm._s(_vm.configObj.card3SubTitle.val)),
            ]),
            _c("div", { staticClass: "mid-img" }, [
              _vm.configObj.card3Img.url
                ? _c("img", {
                    attrs: { src: _vm.configObj.card3Img.url, alt: "" },
                  })
                : _c("div", { staticClass: "empty" }, [
                    _c("i", { staticClass: "el-icon-picture-outline" }),
                  ]),
            ]),
            _vm.configObj.card3Tag.val
              ? _c("div", { staticClass: "bottom-tag" }, [
                  _vm._v(_vm._s(_vm.configObj.card3Tag.val)),
                ])
              : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }